__turbopack_context__.v({
  "backButton": "controls-module-scss-module__DDzrVW__backButton",
  "buttonGroup": "controls-module-scss-module__DDzrVW__buttonGroup",
  "rtl": "controls-module-scss-module__DDzrVW__rtl",
});
